var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloudy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0.335938C14.6546 0.335938 11.68 2.08127 10.028 4.8106C11.316 5.42127 12.6893 6.49594 13.9893 8.34127L12.9 9.10794C10.904 6.2746 9.19063 5.66794 7.33329 5.66794C3.65729 5.66794 0.666626 8.6586 0.666626 12.3346C0.666626 16.0106 3.65729 19.0013 7.33329 19.0013H18C23.1466 19.0013 27.3333 14.8146 27.3333 9.66794C27.3333 4.52394 23.1466 0.335938 18 0.335938Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloudy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloudy.39b645f3e8119b2010d5aa1a4a79b727.svg";